import Cookies from 'universal-cookie'
import {
  CustomerClassificationType,
  SourcingCompany,
} from 'src/graphql/generated/graphql-types'

const url: string = 'https://www.google-analytics.com/collect'

const getTrackingId = (sourcingCompany: SourcingCompany): string | null => {
  switch (sourcingCompany) {
    case SourcingCompany.Dk:
      return 'UA-44123152-4'
    case SourcingCompany.Fi:
      return 'UA-44123152-6'
    case SourcingCompany.Nl:
      return 'UA-44123152-7'
    case SourcingCompany.No:
      return 'UA-44123152-5'
    case SourcingCompany.Se:
      return 'UA-44123152-2'
    default:
      return null
  }
}

export enum UserId {
  None = "no_user_id"
}

export const getCd3 = (customerClassificationType: CustomerClassificationType): string => {
  switch (customerClassificationType) {
    case CustomerClassificationType.Corporate:
    case CustomerClassificationType.DkCorporate:
    case CustomerClassificationType.SeCorporate:
    case CustomerClassificationType.FiCorporate:
    case CustomerClassificationType.NoCorporate:
    case CustomerClassificationType.NoLargeCorpDirect:
      return `Corporate`
    case CustomerClassificationType.Home:
    case CustomerClassificationType.DkHome:
    case CustomerClassificationType.SeHome:
    case CustomerClassificationType.FiHome:
    case CustomerClassificationType.NoHome:
      return `Home`
    case CustomerClassificationType.SmbSmall:
    case CustomerClassificationType.DkSmbSmall:
    case CustomerClassificationType.SeSmbSmall:
    case CustomerClassificationType.FiSmbSmall:
    case CustomerClassificationType.NoSmbSmall:
      return 'SmbSmall'
    case CustomerClassificationType.SmbMid:
    case CustomerClassificationType.DkSmbMid:
    case CustomerClassificationType.SeSmbMid:
    case CustomerClassificationType.FiSmbMid:
    case CustomerClassificationType.NoSmbMid:
      return 'SmbMid'
    case CustomerClassificationType.SmbLarge:
    case CustomerClassificationType.DkSmbLarge:
    case CustomerClassificationType.SeSmbLarge:
    case CustomerClassificationType.FiSmbLarge:
    case CustomerClassificationType.NoSmbLarge:
      return 'SmbLarge'
    case CustomerClassificationType.Public:
    case CustomerClassificationType.DkPublic:
    case CustomerClassificationType.SePublic:
    case CustomerClassificationType.FiPublic:
    case CustomerClassificationType.NoPublic:
      return 'Public'
    case CustomerClassificationType.IcInterCompany:
      return 'IcInterCompany'
    case CustomerClassificationType.None:
    default:
      return "no_customer_unit"
  }
}

export const accountCreated = (sourcingCompany: SourcingCompany) => {
  const c = new Cookies()
  const tid = getTrackingId(sourcingCompany)
  const _cid = c.get('_ga')

  if (!_cid) {
    return
  }

  const cid: string = (_cid as string)?.replace('GA1.1.', '')?.replace('GA1.2.', '')
  const el: string = 'B2B'
  const ea: string = encodeURIComponent('Account Created')
  const dl: string = encodeURIComponent(document.location.origin)

  const payload_data: string = `v=1&tid=${tid}&cid=${cid}&t=event&ec=Login&ea=${ea}&el=${el}&dl=${dl}`

  fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    body: payload_data,
  })
}
